<template>
  <div class="work-checks">
    <div class="work-checks__filters">
      <div class="filters-row">
        <CustomSelect
          :options="projectTypes"
          label="Тип проекта"
          option-label-key="project_type_name"
          option-value-key="project_type_id"
          :value="filters.project_type_id"
          @change="onFilterChange('project_type_id', $event)"
          :loading="isLoadingProjectTypes"
          placeholder="Все типы проектов"
          :clearable="true"
        />
        
        <CustomSelect
          :options="placementTypes"
          label="Тип работ"
          option-label-key="placement_type_name"
          option-value-key="placement_type_id"
          :value="filters.placement_type_id"
          @change="onFilterChange('placement_type_id', $event)"
          :loading="isLoadingPlacementTypes"
          placeholder="Все типы работ"
          :clearable="true"
        />
        
        <CustomSelect
          :options="workSetCheckGroups"
          label="Группа работ"
          option-label-key="work_set_check_group_name"
          option-value-key="work_set_check_group_id"
          :value="filters.work_set_check_group_id"
          @change="onFilterChange('work_set_check_group_id', $event)"
          :loading="isLoadingWorkSetCheckGroups"
          placeholder="Все группы работ"
          :clearable="true"
        />
        
        <CustomSelect
          :options="checkLists"
          label="Чек-лист"
          option-label-key="check_name"
          option-value-key="check_list_id"
          :value="filters.check_list_id"
          @change="onFilterChange('check_list_id', $event)"
          :loading="isLoadingCheckLists"
          placeholder="Все чек-листы"
          :clearable="true"
          class="check-list-filter"
        />
        
        <CustomSelect
          :options="assignTypes"
          label="Исполнитель"
          option-label-key="assign_type_name"
          option-value-key="assign_type_id"
          :value="filters.assign_type_id"
          @change="onFilterChange('assign_type_id', $event)"
          :loading="isLoadingAssignTypes"
          placeholder="Все исполнители"
          :clearable="true"
        />
      </div>
    </div>

    <CustomTable
      title="Связи чек-листов с типом проекта и группой работ"
      :rowsData="rowsData"
      :columns="workChecksTableColumns"
      :stickyHeader="true"
      :loading="isFetching"
      :custom-body="true"
      :custom-header="true"
      :small="true"
    >
      <template #customHeader="props">
        <q-tr :props="props">
          <q-th v-for="col in props.cols" :key="col.name" :props="props">
            <template v-if="col.name === 'actions'">
              <q-btn
                size="sm"
                title="Добавить"
                color="primary"
                dense
                round
                @click="openAddModal"
                icon="add"
              />
            </template>
            <template v-else>
              {{ col.label }}
            </template>
          </q-th>
        </q-tr>
      </template>
      <template #customBody="props" v-if="!isFetching">
        <q-tr>
          <custom-table-cell align="center" vertical-align="center">
            {{ props.row.sbs_work_check_id }}
          </custom-table-cell>

          <custom-table-cell align="left" vertical-align="center">
            {{ props.row.project_type_name || '-' }}
          </custom-table-cell>

          <custom-table-cell align="left" vertical-align="center">
            {{ props.row.placement_type_name || '-' }}
          </custom-table-cell>

          <custom-table-cell align="left" vertical-align="center">
            {{ props.row.work_set_check_group_name || '-' }}
          </custom-table-cell>

          <custom-table-cell align="left" vertical-align="center">
            {{ props.row.check_name || '-' }}
          </custom-table-cell>

          <custom-table-cell align="left" vertical-align="center">
            {{ props.row.assign_type_name || '-' }}
          </custom-table-cell>

          <custom-table-cell align="center" vertical-align="center">
            <div class="action-buttons">
              <q-btn
                @click="openEditModal(props.row)"
                color="primary-light"
                flat
                dense
                round
                size="sm"
                icon="edit"
              >
                <q-tooltip>Редактировать</q-tooltip>
              </q-btn>
              <q-btn
                @click="confirmDelete(props.row)"
                color="negative"
                flat
                dense
                round
                size="sm"
                icon="delete"
                :loading="!!deleteLoading[props.row.sbs_work_check_id]"
              >
                <q-tooltip>Удалить</q-tooltip>
              </q-btn>
            </div>
          </custom-table-cell>
        </q-tr>
      </template>
    </CustomTable>

    <!-- Модальное окно для добавления/редактирования -->
    <q-dialog v-model="modalShow" persistent>
      <q-card class="work-check-modal">
        <q-card-section class="work-check-modal__header">
          <div class="work-check-modal__title">
            {{ editingItem ? 'Редактировать связь' : 'Добавить связь' }}
          </div>
          <q-btn icon="close" flat round dense v-close-popup class="work-check-modal__close" />
        </q-card-section>

        <q-card-section class="work-check-modal__content">
          <q-form @submit.prevent="saveItem" class="work-check-form">
            <div class="work-check-form__section">
              <div class="work-check-form__item">
                <CustomSelect
                  label="Тип проекта"
                  :options="projectTypes"
                  option-label-key="project_type_name"
                  option-value-key="project_type_id"
                  :value="editForm.project_type_id"
                  @change="editForm.project_type_id = $event"
                  :loading="isLoadingProjectTypes"
                  placeholder="Выберите тип проекта"
                  :required="true"
                />
              </div>
              
              <div class="work-check-form__item">
                <CustomSelect
                  label="Тип работ"
                  :options="placementTypes"
                  option-label-key="placement_type_name"
                  option-value-key="placement_type_id"
                  :value="editForm.placement_type_id"
                  @change="editForm.placement_type_id = $event"
                  :loading="isLoadingPlacementTypes"
                  placeholder="Выберите тип работ"
                  :clearable="true"
                />
              </div>
              
              <div class="work-check-form__item">
                <CustomSelect
                  label="Группа работ"
                  :options="workSetCheckGroups"
                  option-label-key="work_set_check_group_name"
                  option-value-key="work_set_check_group_id"
                  :value="editForm.work_set_check_group_id"
                  @change="editForm.work_set_check_group_id = $event"
                  :loading="isLoadingWorkSetCheckGroups"
                  placeholder="Выберите группу работ"
                  :required="true"
                />
              </div>
              
              <div class="work-check-form__item">
                <CustomSelect
                  label="Чек-лист"
                  :options="checkLists"
                  option-label-key="check_name"
                  option-value-key="check_list_id"
                  :value="editForm.check_list_id"
                  @change="editForm.check_list_id = $event"
                  :loading="isLoadingCheckLists"
                  placeholder="Выберите чек-лист"
                  :required="true"
                />
              </div>
              
              <div class="work-check-form__item">
                <CustomSelect
                  label="Исполнитель"
                  :options="assignTypes"
                  option-label-key="assign_type_name"
                  option-value-key="assign_type_id"
                  :value="editForm.assign_type_id"
                  @change="editForm.assign_type_id = $event"
                  :loading="isLoadingAssignTypes"
                  placeholder="Выберите исполнителя"
                  :clearable="true"
                />
              </div>
            </div>

            <div class="work-check-modal__footer">
              <CustomButton
                @click="closeModal"
                :disabled="saving"
                outlined
              >
                Отмена
              </CustomButton>
              <CustomButton
                type="submit"
                :loading="saving"
                :disabled="!editForm.project_type_id || !editForm.work_set_check_group_id || !editForm.check_list_id"
              >
                {{ editingItem ? 'Сохранить' : 'Создать' }}
              </CustomButton>
            </div>
          </q-form>
        </q-card-section>
      </q-card>
    </q-dialog>

    <!-- Диалог подтверждения удаления -->
    <q-dialog v-model="confirmDeleteDialog" persistent>
      <q-card style="min-width: 350px">
        <q-card-section>
          <div class="text-h6">Подтверждение удаления</div>
        </q-card-section>

        <q-card-section>
          Вы уверены, что хотите удалить эту связь?
        </q-card-section>

        <q-card-actions align="right">
          <q-btn flat label="Отмена" color="grey" @click="confirmDeleteDialog = false" />
          <q-btn unelevated label="Удалить" color="negative" @click="onDeleteSubmit" />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import CustomTable from "@/components/common/CustomTable";
import CustomTableCell from "@/components/common/CustomTable/custom-table-cell";
import CustomSelect from "@/components/form/CustomSelect";
import CustomButton from "@/components/common/CustomButton.vue";
import { useCustomSnackbar } from "@/_helpers/hooks/useCustomSnackbar";
import {
  getWorkChecksList,
  modifyWorkCheck,
  deleteWorkCheck,
  getProjectTypes,
  getWorkSetCheckGroups,
  getCheckLists,
  getAllPlacementTypes,
  getAssignTypes,
  workChecksTableColumns,
} from "@/views/WorkChecks/services";

const { showSucceedSnackbar, showErrorSnackbar } = useCustomSnackbar();

// State
const rowsData = ref([]);
const isFetching = ref(false);
const saving = ref(false);
const modalShow = ref(false);
const editingItem = ref(null);
const editForm = ref({
  sbs_work_check_id: null,
  project_type_id: null,
  work_set_check_group_id: null,
  check_list_id: null,
  placement_type_id: null,
  assign_type_id: null,
});
const deleteLoading = ref({});
const confirmDeleteDialog = ref(false);
const itemToDelete = ref(null);
const filters = ref({
  project_type_id: null,
  placement_type_id: null,
  work_set_check_group_id: null,
  check_list_id: null,
  assign_type_id: null,
});
const projectTypes = ref([]);
const placementTypes = ref([]);
const workSetCheckGroups = ref([]);
const checkLists = ref([]);
const assignTypes = ref([]);
const isLoadingProjectTypes = ref(false);
const isLoadingPlacementTypes = ref(false);
const isLoadingWorkSetCheckGroups = ref(false);
const isLoadingCheckLists = ref(false);
const isLoadingAssignTypes = ref(false);

// Methods
const buildParams = () => {
  const params = {};
  
  if (filters.value.project_type_id !== null) {
    params.project_type_id = filters.value.project_type_id;
  }
  if (filters.value.placement_type_id !== null) {
    params.placement_type_id = filters.value.placement_type_id;
  }
  if (filters.value.work_set_check_group_id !== null) {
    params.work_set_check_group_id = filters.value.work_set_check_group_id;
  }
  if (filters.value.check_list_id !== null) {
    params.check_list_id = filters.value.check_list_id;
  }
  if (filters.value.assign_type_id !== null) {
    params.assign_type_id = filters.value.assign_type_id;
  }
  
  return params;
};

const getData = async () => {
  isFetching.value = true;
  const params = buildParams();
  const res = await getWorkChecksList(params);
  isFetching.value = false;
  if (!res) return;
  rowsData.value = res || [];
};

const getDataSilently = async () => {
  const params = buildParams();
  const res = await getWorkChecksList(params);
  if (!res) return;
  rowsData.value = res || [];
};

const loadProjectTypes = async () => {
  isLoadingProjectTypes.value = true;
  const res = await getProjectTypes();
  isLoadingProjectTypes.value = false;
  if (!res) return;
  projectTypes.value = res || [];
};

const loadWorkSetCheckGroups = async () => {
  isLoadingWorkSetCheckGroups.value = true;
  const res = await getWorkSetCheckGroups();
  isLoadingWorkSetCheckGroups.value = false;
  if (!res) return;
  workSetCheckGroups.value = res || [];
};

const loadCheckLists = async () => {
  isLoadingCheckLists.value = true;
  const res = await getCheckLists();
  isLoadingCheckLists.value = false;
  if (!res) return;
  checkLists.value = res || [];
};

const loadPlacementTypes = async () => {
  isLoadingPlacementTypes.value = true;
  const res = await getAllPlacementTypes();
  isLoadingPlacementTypes.value = false;
  if (!res) return;
  placementTypes.value = res || [];
};

const loadAssignTypes = async () => {
  isLoadingAssignTypes.value = true;
  const res = await getAssignTypes();
  isLoadingAssignTypes.value = false;
  if (!res) return;
  assignTypes.value = res || [];
};

const onFilterChange = (key, value) => {
  filters.value[key] = value;
  getData();
};

const openAddModal = () => {
  editingItem.value = null;
  resetEditForm();
  modalShow.value = true;
};

const openEditModal = (item) => {
  editingItem.value = item;
  editForm.value = {
    sbs_work_check_id: item.sbs_work_check_id,
    project_type_id: item.project_type_id,
    placement_type_id: item.placement_type_id,
    work_set_check_group_id: item.work_set_check_group_id,
    check_list_id: item.check_list_id,
    assign_type_id: item.assign_type_id,
  };
  modalShow.value = true;
};

const closeModal = () => {
  modalShow.value = false;
  editingItem.value = null;
  resetEditForm();
};

const saveItem = async () => {
  if (
    !editForm.value.project_type_id ||
    !editForm.value.work_set_check_group_id ||
    !editForm.value.check_list_id
  ) {
    showErrorSnackbar("Все поля обязательны для заполнения");
    return;
  }

  saving.value = true;
  const body = {
    sbs_work_check_id: editingItem.value?.sbs_work_check_id || null,
    project_type_id: editForm.value.project_type_id,
    placement_type_id: editForm.value.placement_type_id || null,
    work_set_check_group_id: editForm.value.work_set_check_group_id,
    check_list_id: editForm.value.check_list_id,
    assign_type_id: editForm.value.assign_type_id || null,
  };

  const result = await modifyWorkCheck(body);
  saving.value = false;
  if (!result) return;
  
  showSucceedSnackbar(
    editingItem.value ? "Связь обновлена" : "Связь добавлена"
  );
  
  closeModal();
  
  // Всегда обновляем данные с учетом текущих фильтров
  await getDataSilently();
};

const resetEditForm = () => {
  editForm.value = {
    sbs_work_check_id: null,
    project_type_id: null,
    placement_type_id: null,
    work_set_check_group_id: null,
    check_list_id: null,
    assign_type_id: null,
  };
};

const confirmDelete = (item) => {
  itemToDelete.value = item;
  confirmDeleteDialog.value = true;
};

const onDeleteSubmit = async () => {
  if (!itemToDelete.value) return;
  
  const sbsWorkCheckId = itemToDelete.value.sbs_work_check_id;
  
  if (deleteLoading.value[sbsWorkCheckId]) return;
  deleteLoading.value = {
    ...deleteLoading.value,
    [sbsWorkCheckId]: true,
  };
  
  confirmDeleteDialog.value = false;
  
  const res = await deleteWorkCheck(sbsWorkCheckId);
  deleteLoading.value = {
    ...deleteLoading.value,
    [sbsWorkCheckId]: false,
  };
  
  if (!res) return;
  
  showSucceedSnackbar("Связь удалена");
  
  // Всегда обновляем данные с учетом текущих фильтров
  await getDataSilently();
  
  itemToDelete.value = null;
};

// Lifecycle
onMounted(async () => {
  await Promise.all([
    loadProjectTypes(),
    loadPlacementTypes(),
    loadWorkSetCheckGroups(),
    loadCheckLists(),
    loadAssignTypes(),
  ]);
  await getData();
});
</script>

<style scoped lang="scss">
.work-checks {
  padding: 16px;
  height: calc(100vh - 80px);
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow: hidden;
}

.work-checks__filters {
  background: white;
  border: 1px solid #ddd;
  padding: 16px;
  border-radius: 4px;
  flex-shrink: 0;
}

.filters-row {
  display: flex;
  gap: 16px;
  align-items: flex-end;
  flex-wrap: wrap;
}

.filters-row > * {
  min-width: 200px;
}

.filters-row .check-list-filter {
  flex: 1;
}

:deep(.filters-row .q-field) {
  width: 100%;
}

:deep(.filters-row .q-field__control) {
  width: 100%;
}

:deep(.filters-row .q-select) {
  position: relative;
}

:deep(.filters-row .q-select .q-menu) {
  min-width: 0 !important;
  width: 100% !important;
  max-width: 100% !important;
}

:deep(.filters-row .q-select .q-menu .q-list) {
  min-width: 100%;
  width: 100%;
}

:deep(.filters-row .q-item) {
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

:deep(.filters-row .q-item__label) {
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.action-buttons {
  display: flex;
  flex-direction: row;
  gap: 8px;
  justify-content: center;
  align-items: center;
}

:deep(.custom-table) {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

:deep(.custom-table__container) {
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

/* Стили модального окна */
.work-check-modal {
  min-width: 500px;
  max-width: 700px;
}

.work-check-modal__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #e5e7eb;
}

.work-check-modal__title {
  font-size: 20px;
  font-weight: 600;
  color: #373D48;
  line-height: 20px;
}

.work-check-modal__close {
  color: #9CA3AF;
}

.work-check-modal__content {
  padding: 20px 24px;
}

.work-check-form {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 15px;
}

.work-check-form__section {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.work-check-form__item {
  width: 100%;
}

.work-check-modal__footer {
  width: 100%;
  height: 46px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
  margin-top: 15px;
}

@media (max-width: 600px) {
  .work-check-modal {
    min-width: 100%;
  }
}
</style>
